import styled from 'styled-components';
import {fieldSet} from 'styles/fragments';

export default styled.fieldset`
	${fieldSet};
`;
